import axios from 'axios';
import { environment } from 'src/environment';

let promise: Promise<{ data: { Currency: string } }>;
let config = null;
export const getFirmConfig = () => {
  if (config) {
    return config;
  }
  if (!promise) {
    promise = axios.get(`${environment.reportingEndpoint}/api/firmconfiguration`);
  }
  return promise
    .then((res) => {
      config = res.data;
      return config;
    })
    .catch((err) => {
      config = {
        error: true,
      };
      return config;
    });
};

export const getCurrencySymbol = () => {
  return getFirmConfig()?.Currency || '';
};
